import { SxProps, Theme } from '@mui/material';

export const tabsStyles: SxProps<Theme> = {
    mb: 2,
};

export const fieldStyles: SxProps<Theme> = {
    mt: 2,
};

/**
 * The patient picker with *Add patient* beside it. Aligned to the top, so an error line
 * under the field grows the field downwards instead of pulling the button off its input.
 */
export const patientRowStyles: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 1,
    mt: 2,
};

/** Takes whatever width the button leaves. `minWidth: 0` lets it shrink below its content. */
export const patientPickerStyles: SxProps<Theme> = { flex: 1, minWidth: 0 };

/**
 * As tall as the small outlined input it sits beside, and never squeezed by it. `height`
 * rather than `minHeight`, so the theme's 44px touch floor still wins on a coarse pointer.
 */
export const addPatientButtonStyles: SxProps<Theme> = {
    flexShrink: 0,
    height: 40,
    py: 0,
    whiteSpace: 'nowrap',
};
